"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.monitoring = void 0;
const monitoring_1 = require("@wix/monitoring");
const host_modules_1 = require("@wix/sdk-runtime/host-modules");
exports.monitoring = (0, host_modules_1.createHostModule)({
    getMonitoringClient: (host) => () => {
        if (!host.getMonitoringClient) {
            return (0, monitoring_1.createFallbackMonitoringClient)('Host monitoring client is not available on the current host. Make sure to use an updated version of the host initialization package.');
        }
        return host.getMonitoringClient();
    },
});
